import { RevealText } from "@/components/shared/RevealText";
import { CTAButton } from "@/components/shared/CTAButton";
import { AnimatedSection } from "@/components/shared/AnimatedSection";

export const CTASection = ({
  heading,
  description,
  primaryLabel,
  primaryTo,
  secondaryLabel,
  secondaryTo,
  testIdPrefix = "cta",
}) => (
  <section className="relative bg-navy py-24 px-6 overflow-hidden">
    <div className="absolute inset-0 opacity-[0.05] bg-[radial-gradient(circle_at_20%_20%,white,transparent_45%)]" />
    <div className="max-w-4xl mx-auto text-center relative">
      <RevealText
        as="h2"
        text={heading}
        className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-cream leading-tight tracking-tight"
      />
      <AnimatedSection delay={0.3}>
        <p className="mt-6 text-cream/70 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">{description}</p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <CTAButton to={primaryTo} variant="primary" testId={`${testIdPrefix}-primary`}>
            {primaryLabel}
          </CTAButton>
          {secondaryLabel && (
            <CTAButton to={secondaryTo} variant="ghost" testId={`${testIdPrefix}-secondary`}>
              {secondaryLabel}
            </CTAButton>
          )}
        </div>
      </AnimatedSection>
    </div>
  </section>
);
